<template>
  <div>✨{{pageName}}✨
    <h3 v-if="itsYourTurn">✨It's Your Turn!✨</h3>
    <p v-for="entity in turnOrderListGone" :key="entity.id">
      {{ entity.name }} ✓
    </p>
    <p v-bind:class="{itsYourTurn: checkIfEntityTurn(entity), enemy: checkIfEnemy(entity)}" v-for="entity in turnOrderListNotGone" :key="entity.id">
      {{ entity.name }} {{ entity.initiative }} {{ entity.subInitiative }} 
    </p>
    <button v-if="!lastEntityHasGone" type="submit" name="action" @click="undo" class="undo btn-large black">Undo Turn</button>
    <button v-if="!lastEntityHasGone" type="submit" name="action" @click="endTurn" class="endTurn btn-large">End Turn</button>
    
    <!-- <br> <br> 
    <div>
      <hr>
      BATTLE ARENA
      <hr>
      <div class="battle">
        <p class="battlelistplayers" v-for="entity in presentCharacters" :key="entity.id">
          {{ entity.name }}
        </p>
        <p class="battlelistvillians" v-for="entity in presentMonsters" :key="entity.id">
          {{ entity.name }}
        </p>
        <p class="battlelistvillians" v-for="entity in presentBosses" :key="entity.id">
          {{ entity.name }}
        </p>
      </div>
    </div> -->
    
    <div v-if="lastEntityHasGone" class="input-field inline">
      <input type="checkbox" name="elementsReduced" v-model="watcherDoc.elementsReduced" class="filled-in" @click="$emit('watcherdoc-update', 'elementsReduced', true)">
      <span style="color: deepskyblue" @click="$emit('watcherdoc-update', 'elementsReduced', true)">
        DID YOU RESET THE ELEMENTS?
      </span>
    </div>
    <br>
    <div v-if="watcherDoc.elementsReduced" class="input-field inline">
      <input type="checkbox" name="elementsReduced" v-model="watcherDoc.allShufflesShuffled" class="filled-in" @click="$emit('watcherdoc-update', 'allShufflesShuffled', true)">
      <span style="color: deepskyblue" @click="$emit('watcherdoc-update', 'allShufflesShuffled', true)">
        DID YOU SHUFFLE THE MODIFIER DECKS?!
      </span>
    </div>
    <br>
    <button v-if="watcherDoc.allShufflesShuffled" type="submit" name="action" @click="roundOver" class="roundOver btn-large">Round Over</button>
    <LoadingRound
      :entitiesHaveLoaded="entitiesHaveLoaded"
      :scenarioMonsters="scenarioMonsters"
      :scenarioBosses="scenarioBosses"
      :deleteEntity="deleteEntity"
      :toggleActivation="toggleActivation"
      :playerIsGM="playerIsGM"
      :playerCharacter="playerCharacter"

      @toggle-presence="togglePresence"
      @update-presence="updatePresence"
      @entity-update="entityUpdate"
    >
    </LoadingRound>
  </div>
</template>

<script>
import LoadingRound from '@/components/LoadingRound'

export default {
  name: 'TurnOrder',
  components: {LoadingRound},
  props: [
    'presentCharacters',
    'presentMonsters',
    'presentBosses',
    'playerCharacter',
    'presentEntities',
    'entitiesHaveLoaded',
    'scenarioMonsters',
    'scenarioBosses',
    'deleteEntity',
    'toggleActivation',
    'playerIsGM',
    'playerCharacter',
    'togglePresence',
    'updatePresence',
    'entityUpdate',
    'watcherDoc'
  ],
  data () {
    return {
      pageName: 'TurnOrder',
      watchForSleepyPhones: false
    }
  },
  methods: {
    checkIfEntityTurn(entity){
      return entity == this.entityUpNow
    },
    checkIfEnemy(entity){
      console.log(entity.type)
      return (entity.type == "monster" || entity.type =="boss")
    },
    undo(){
      let lastEntityPlayed = this.turnOrderListGone[this.turnOrderListGone.length-1]
      lastEntityPlayed.hasGone = false
      this.$emit('entity-update', lastEntityPlayed, "hasGone")
    },
    endTurn() {
       let entity = this.presentBoardEntitiesNotGone[0]
       entity.hasGone = true
       this.entityPlacholder = entity 
       this.$emit('entity-update', entity, "hasGone")
    },
    roundOver() {
      this.watchForSleepyPhones = true
      this.watcherDoc.readyToRestartRound = true
      this.$emit('watcherdoc-update', 'readyToRestartRound')
      this.$router.push({ name: 'RoundPrep' })
      
      let newRoundNumber = this.watcherDoc.roundCount + 1
      this.$emit('watcherdoc-update', 'roundCount', newRoundNumber)

      this.presentBoardEntitiesGone.forEach(entity => {
        entity.hasGone = false
        entity.initiative = ""
        entity.subInitiative = ""
        this.$emit('entity-update', entity, "hasGone")
        this.$emit('entity-update', entity, "initiative")
        this.$emit('entity-update', entity, "subInitiative")
      })
      
    },
    sortList(list){
      return list.sort((EA,EB) => {
        let EAI = parseInt(EA.initiative)
        let EBI = parseInt(EB.initiative)
        if(EAI == EBI){
          let EASI = parseInt(EA.subInitiative)
            if(isNaN(EASI) || EASI == 0 ){
              EASI = 100
            }
          let EBSI = parseInt(EB.subInitiative)
            if(isNaN(EBSI) || EBSI == 0){
              EBSI = 100
            }
          return EASI - EBSI
        } else { 
          return EAI - EBI
        }
      })
    }
  },
    
  // create computed list of entities based on initiative called turnOrderList?
  computed: {
    presentBoardEntities() {
      return this.presentEntities.filter(entity => entity.type in {player:1, boss:1, monster:1, ally:1})
    },
    presentBoardEntitiesNotGone() {
      return this.presentBoardEntities.filter(entity => !entity.hasGone)
    },
    presentBoardEntitiesGone() {
      return this.presentBoardEntities.filter(entity => entity.hasGone)
    },
    turnOrderListNotGone() {
      return this.sortList(this.presentBoardEntitiesNotGone)
    },
    turnOrderListGone() {
      return this.sortList(this.presentBoardEntitiesGone)
    },
    entityUpNow() {
      return this.turnOrderListNotGone[0]
    },
    itsYourTurn() {
      return this.entityUpNow == this.playerCharacter
    },
    lastEntityHasGone() {
      return this.presentBoardEntitiesNotGone.length == 0
    }
  },
  watch: {
    'watcherDoc.readyToRestartRound': function(newVal, oldVal) {
      if (this.watcherDoc.readyToRestartRound) {
        this.$router.push({ name: 'RoundPrep' })
      }
    },
    'watchForSleepyPhones': function(newVal, oldVal) {
      if (this.watchForSleepyPhones) {
        this.$router.push({ name: 'RoundPrep' })
        this.watchForSleepyPhones = false
      }
    }
  }
}
</script>

<style scoped>
p{
  font-size: 14pt;
}
.itsYourTurn{
  font-weight: bold;
}
.enemy{
  color: red;
}
hr{
  width: 50%;
}
.battle{
  display: grid;
  grid-template-columns: 300px 300px;
  justify-content: center;
}
.battlelistplayers{
  grid-column-start: 1;
  grid-column-end: 1;
}
.battlelistvillians{
  grid-column-start: 2;
  grid-column-end: 2;
}

</style>


// WEBPACK FOOTER //
// src/components/TurnOrder.vue